import Layout from "@/layout";
import Home from "./Home";
import Commodity from "./Commodity";
import StoreCommodity from "./StoreCommodity";
import PurchasingManagement from "./PurchasingManagement"
import SupplierManagement from "./SupplierManagement"
import Store from "./Store";
import Order from "./Order";
import Stock from "./Stock";
import Customer from "./Customer";
import Marketing from "./Marketing";
import ShoppingMall from "./ShoppingMall";
import ReportForm from "./ReportForm";
import MapDepot from "./MapDepot";
import System from "./System";
import AuditManagement from "./AuditManagement";
import Message from "./Message";
import UserMobileTerminalManagement from "./UserMobileTerminalManagement";
export default {
  path: "/HeadOfficeManagement",
  component: Layout,
  redirect: "/HeadOfficeManagement/Home",
  name: "HeadOfficeManagement",
  hidden: false,
  meta: {
    title: "城投助农",
    keepAlive: false
    // activeMenu: '/UrbanIntegration/BasicDataManage/BasicData'
  },
  children: [
    Home,
    Commodity,
    StoreCommodity,
    // PurchasingManagement,
    SupplierManagement,
    Store,
    Order,
    Stock,
    Customer,
    Marketing,
    Message,
    ShoppingMall,
    AuditManagement,
    ReportForm,
    MapDepot,
    System,
    // UserMobileTerminalManagement,
  ]
};
